module.exports = "/dist/images/cs.bbc2ed67.png";